'use client';

/* eslint-disable prettier/prettier */
var translations = {
    Cancel: 'Hủy',
    Edit: 'Sửa',
    Delete: 'Xoá'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
